
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/download/ai-ux-sprint",
      function () {
        return require("private-next-pages/download/ai-ux-sprint/index.tsx");
      }
    ]);
  